import React, { ReactNode } from 'react'

import { Button, Dialog, DialogProps } from '@mui/material'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'

export type BaseDialogProps = Pick<DialogProps, 'classes' | 'maxWidth' | 'fullWidth'> & {
  title: ReactNode
  description?: ReactNode
  open: boolean
  onClose: () => void
  actions: ReactNode
}

function BaseDialog({ title, description, open, onClose, actions, ...otherProps }: BaseDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      {...otherProps}
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText component="div" id="alert-dialog-description">
          {description}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
        {actions}
      </DialogActions>
    </Dialog>
  )
}

export default BaseDialog
